import {
  Button,
  Flex,
  HStack,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
} from '@chakra-ui/react';
import { useEffect, useRef, useState } from 'react';
import { LuChevronDown, LuChevronLeft, LuChevronRight } from 'react-icons/lu';
import { LoadingStt } from '../pages/ContractsPage';
interface ContractsTablePaginationProps {
  perPage: number;
  selectedPage: number;
  total: number;
  onPerPageChange?: (value: number) => void;
  onPageChange?: (value: number) => void;
  loading?: LoadingStt;
}

const ContractsTablePagination = ({
  perPage,
  total,
  selectedPage,
  onPerPageChange,
  onPageChange,
  loading,
}: ContractsTablePaginationProps) => {
  const rangeDisplayPages = 3;
  const perPageOptions = [5, 10, 15, 20, 30, 50];
  const [displayPages, setDisplayPages] = useState<number[]>([]);
  const totalPages = Math.ceil(total / perPage);
  const initialFocusRef = useRef<HTMLButtonElement | null>(null);
  const handleChangePage = (page: number): void => {
    if (page < 1 || page > totalPages) return;
    onPageChange?.(page);
  };

  useEffect(() => {
    if (totalPages > 5) {
      const startPage = Math.max(
        Math.min(
          selectedPage - Math.floor(rangeDisplayPages / 2),
          totalPages - rangeDisplayPages + 1,
        ),
        1,
      );
      setDisplayPages(
        Array.from({ length: rangeDisplayPages }, (_, i) => startPage + i),
      );
    } else {
      setDisplayPages(Array.from({ length: totalPages }, (_, i) => i + 1));
    }
  }, [selectedPage, rangeDisplayPages, totalPages, perPage]);
  return (
    <Flex
      justify={'space-between'}
      align="center"
      w={'100%'}
      px={8}
      py={2}
      border="1px solid"
      borderColor="gray.200"
      borderRadius="6px"
    >
      <Menu variant="plainSmall" initialFocusRef={initialFocusRef}>
        <MenuButton
          as={Button}
          isDisabled={loading?.stt && loading.first}
          rightIcon={<LuChevronDown />}
          variant="plain"
        >
          <Text variant="regular">Exibindo {perPage} itens</Text>
        </MenuButton>
        <MenuList>
          {perPageOptions.map((option, i) => (
            <MenuItem
              bg={option === perPage ? 'yPrimary.100' : ''}
              color={option === perPage ? 'yPrimary.600' : ''}
              ref={option === perPage ? initialFocusRef : null}
              isFocusable={i === 1}
              key={option}
              onClick={() => onPerPageChange?.(option)}
            >
              {option}
            </MenuItem>
          ))}
        </MenuList>
      </Menu>
      <Text
        opacity={loading?.stt && loading.first ? '.5' : '1'}
        variant="regular"
      >
        {total} itens
      </Text>
      <HStack>
        <Button
          variant="plainIcon"
          size="small"
          isDisabled={selectedPage === 1 || (loading?.stt && loading.first)}
          onClick={() => handleChangePage(selectedPage - 1)}
        >
          <LuChevronLeft />
        </Button>
        {selectedPage > 3 && (
          <>
            <Button
              onClick={() => handleChangePage(1)}
              variant="plain"
              isDisabled={loading?.stt && loading.first}
              size="small"
            >
              1
            </Button>
            <Text>...</Text>
          </>
        )}
        {displayPages.map((page) => (
          <Button
            onClick={() => handleChangePage(page)}
            key={page}
            variant={'plain'}
            isDisabled={loading?.stt && loading.first}
            colorScheme={selectedPage === page ? 'selected' : ''}
            size="small"
          >
            {page}
          </Button>
        ))}
        {selectedPage < totalPages - 2 && (
          <>
            <Text>...</Text>
            <Button
              onClick={() => handleChangePage(totalPages)}
              variant="plain"
              size="small"
              isDisabled={loading?.stt && loading.first}
            >
              {totalPages}
            </Button>
          </>
        )}
        <Button
          variant="plainIcon"
          size="small"
          isDisabled={
            selectedPage === totalPages || (loading?.stt && loading.first)
          }
          onClick={() => handleChangePage(selectedPage + 1)}
        >
          <LuChevronRight />
        </Button>
      </HStack>
    </Flex>
  );
};
export default ContractsTablePagination;
